// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__-DmKU","label":"SetPasswdForm_label__JETNt"};